import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import VueLazyload from "vue-lazyload";

Vue.use(ElementUI);
// 懒加载
Vue.use(VueLazyload);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: require("@/assets/home/nav_logo.png"),
  error: require("@/assets/home/nav_logo.png"),
  attempt: 1,
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
